const PROGRAM_HOME_URL = '/programs/';
const PURCHASE_URL = '/purchase/plan/';

export const getProgramHomeLink = (programSlug?: string) => {
  return `${PROGRAM_HOME_URL}${programSlug}`;
};

export const getPurchaseLink = () => {
  return PURCHASE_URL;
};

export const getPurchaseLinkWithOrg = ({ thirdPartyOrganizationId }: { thirdPartyOrganizationId: string }) => {
  return `${PURCHASE_URL}?thirdPartyOrganizationId=${thirdPartyOrganizationId}`;
};
